import React from "react";
import { Image } from "react-bootstrap";
import {
  ORDER_STATUS,
  ORDER_TYPE,
  PAYMENT_STATUS,
  PAYMENT_TYPE,
} from "../../../../../enums/OrderEnums";
import {
  ORDER_STATUS_BADGE,
  PAYMENT_STATUS_BADGE,
} from "../../../../../enums/StatusBadges";
import moment from "moment";

function TableHead(props) {
  return (
    <tr>
      <th style={{ width: "150px" }}>
        Order Type/ <br />
        Order ID
      </th>
      <th style={{ width: "150px" }}>User Name</th>
      <th style={{ width: "150px" }}>
        Order Status <br />
        /Date & Time
      </th>
      <th style={{ width: "150px" }}>
        No.of <br />
        Items
      </th>
      <th style={{ width: "150px" }}>
        Net <br />
        Amount
      </th>
      <th style={{ width: "150px" }}>
        Order <br />
        Total
      </th>
      <th style={{ width: "150px" }}>
        Sales <br />
        Tax
      </th>
      <th style={{ width: "150px" }}>Surcharges</th>
      <th style={{ width: "150px" }}>
        CC <br />
        Charges
      </th>
      <th style={{ width: "150px" }}>Net Remitted</th>
      <th style={{ width: "150px" }}>Discount</th>
      <th style={{ width: "150px" }}>Tip</th>
      <th style={{ width: "150px" }}>Donation</th>
      <th style={{ width: "150px" }}>
        Payment Status <br />
        /Date & Time
      </th>
      <th style={{ width: "150px" }}>
        Payment Method/ <br />
        Transaction ID
      </th>
      <th style={{ width: "150px" }}>
        Refund/ <br />
        Cancellation
      </th>
      <th style={{ width: "150px" }}>Substitution</th>
      <th style={{ width: "300px" }}>
        Refund or Cancellation <br />
        Status/ID
      </th>
      <th style={{ width: "150px" }}>
        Remittance <br />
        Status/ID
      </th>
      <th style={{ width: "150px" }}>
        Merchant Account <br />
        No. & IFSC
      </th>
      <th style={{ width: "150px" }}>
        Settlement Date <br />& Time
      </th>
    </tr>
  );
}

export default TableHead;

export const TableBody = (props) => {
  const data = props.data;
  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px", lineBreak: "anywhere" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              <tr
                className="sd_body_table-row"
                // style={{ textAlign: "center" }}
              >
                <td style={{ width: "150px" }}>
                  <div className="f12-500">
                    {ORDER_TYPE[data?.order?.order_type]}
                  </div>
                  <div className="f12-500">#{props.index}</div>
                </td>
                <td style={{ width: "150px" }} className="text-center">
                  <div className="f12-500">
                    {data?.order?.user_id?.first_name}
                    {data?.order?.user_id?.last_name}
                  </div>
                </td>
                <td style={{ width: "150px" }} className="text-center">
                  <div className="badge badge-warning">
                    {ORDER_STATUS[data?.order?.order_status]}
                  </div>
                  <div className="f12-500">
                    25th Aug, 2020 <br />
                    09:15 PM
                  </div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">
                    {data?.order?.order_items.length}
                  </div>
                </td>

                <td style={{ width: "150px" }}>
                  <div className="f12-500">
                    ₹ {data?.order?.total_amount || 0}
                  </div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">
                    ₹ {data?.order?.total_amount || 0}
                  </div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">
                    ₹ {data?.order?.tax_amount || 0}
                  </div>
                </td>

                <td style={{ width: "150px" }}>
                  <div className="f12-500">-</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">-</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">-</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">
                    {data?.order?.discount?.amount ? (
                      <>₹ {data?.order?.discount?.amount || 0}</>
                    ) : (
                      <>{data?.order?.discount?.percentage || 0} %</>
                    )}
                  </div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">
                    ₹ {data?.order?.tip?.amount || 0}
                  </div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">
                    ₹ {data?.order?.donation?.amount || 0}
                  </div>
                </td>
                <td style={{ width: "150px" }}>
                  <div
                    className={`badge badge-${
                      ORDER_STATUS_BADGE[data?.order?.payment_status]
                    }`}
                  >
                    {ORDER_STATUS[data?.order?.payment_status]}
                  </div>
                  <div className="f12-500">
                    25th Aug, 2020 <br />
                    09:15 PM
                  </div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">
                    {PAYMENT_TYPE[data?.order?.payment_method]}
                  </div>
                  <div className="f12-500">
                    {data?.order?.transactional_id?._id}
                  </div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">₹ 90</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">₹ 90</div>
                </td>
                <td style={{ width: "300px" }}>
                  <div className="f12-500">Successful</div>
                  <div className="f12-500">1245789632</div>
                </td>
                <td style={{ width: "150px" }}>
                  <div
                    className={`badge badge-${
                      PAYMENT_STATUS_BADGE[data?.settle_payment_status]
                    }`}
                  >
                    {PAYMENT_STATUS[data?.settle_payment_status]}
                  </div>
                  <div className="f12-500">
                    {moment(data?.order?.transactional_id?.createdAt).format(
                      "ll"
                    )}
                    <br />
                    {moment(data?.order?.transactional_id?.createdAt).format(
                      "LT"
                    )}
                  </div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">
                    {data?.settlement_account_details?.account_number}/{" "}
                  </div>
                  <div className="f12-500">
                    {data?.settlement_account_details?.account_ifsc}
                  </div>
                </td>
                <td style={{ width: "150px" }}>
                  <div className="f12-500">
                    {moment(data?.order?.transactional_id?.createdAt).format(
                      "ll"
                    )}
                    <br />
                    {moment(data?.order?.transactional_id?.createdAt).format(
                      "LT"
                    )}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};
